module.exports = __webpack_public_path__ + "img/darkgrownflowheader.ae9b3db9.png";